import PlansRibbon from "./PlansRibbon";

export default PlansRibbon;
